import { FaFacebook, FaLinkedin, FaEnvelope, FaPhone, FaMapMarkerAlt, FaHeart } from "react-icons/fa";
import {FaXTwitter} from "react-icons/fa6"
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../assets/images/Impact_Logo.png";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white font-body relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-tr from-secondary/10 to-primary/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
      </div>

      {/* Custom styles */}
      <style>{`
        .footer-card {
          background: linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 1rem;
          transition: all 0.3s ease;
        }

        .footer-card:hover {
          background: linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.04) 100%);
          border-color: rgba(255,255,255,0.2);
          transform: translateY(-2px);
        }

        .social-icon {
          background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%);
          border: 1px solid rgba(255,255,255,0.1);
          transition: all 0.3s ease;
        }

        .social-icon:hover {
          background: linear-gradient(135deg, #99246A 0%, #16A7C4 100%);
          border-color: transparent;
          transform: translateY(-3px) scale(1.1);
        }

        .footer-link {
          position: relative;
          transition: all 0.3s ease;
        }

        .footer-link::after {
          content: '';
          position: absolute;
          width: 0;
          height: 2px;
          bottom: -2px;
          left: 0;
          background: linear-gradient(90deg, #99246A 0%, #16A7C4 100%);
          transition: width 0.3s ease;
        }

        .footer-link:hover::after {
          width: 100%;
        }

        @media (max-width: 640px) {
          .footer-card {
            margin-bottom: 1rem;
          }
          
          .newsletter-input {
            flex-direction: column;
            gap: 0.75rem;
          }
          
          .newsletter-input input,
          .newsletter-input button {
            width: 100%;
          }
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 sm:py-16 relative z-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {/* Company Info */}
          <motion.div
            className="footer-card p-4 sm:p-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
            <img src={logo} alt="Impact Together" className="w-32 h-16 md:w-40 md:h-20" />
            </div>
            <p className="text-gray-300 leading-relaxed text-xs sm:text-sm">
              Driving positive social change through collaboration, innovation, and impact-driven strategy.
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            className="footer-card p-4 sm:p-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="text-base sm:text-lg font-semibold text-white mb-3 sm:mb-4 flex items-center gap-2">
              <div className="w-1 h-4 sm:h-6 bg-gradient-to-b from-primary to-secondary rounded-full"></div>
              Quick Links
            </h4>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
              <li><Link to="/" className="footer-link text-gray-300 hover:text-white">Home</Link></li>
              <li><Link to="/about" className="footer-link text-gray-300 hover:text-white">About Us</Link></li>
              <li><Link to="/initiatives" className="footer-link text-gray-300 hover:text-white">Our Initiatives</Link></li>
              <li><Link to="/team" className="footer-link text-gray-300 hover:text-white">Team</Link></li>
              <li><Link to="/contact" className="footer-link text-gray-300 hover:text-white">Contact</Link></li>
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            className="footer-card p-4 sm:p-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="text-base sm:text-lg font-semibold text-white mb-3 sm:mb-4 flex items-center gap-2">
              <div className="w-1 h-4 sm:h-6 bg-gradient-to-b from-primary to-secondary rounded-full"></div>
              Contact
            </h4>
            <ul className="space-y-3 sm:space-y-4 text-xs sm:text-sm">
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="social-icon w-6 h-6 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center mt-1 flex-shrink-0">
                  <FaMapMarkerAlt className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
                </div>
                <span className="text-gray-300">
                  A/203, Sai Shubham heights, <br />
                  Nr. Deshmane clinic , Raikar mala, <br />
                  Dhayari Pune - 411041
                </span>
              </li>
              <li className="flex items-center gap-2 sm:gap-3">
                <div className="social-icon w-6 h-6 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FaPhone className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
                </div>
                <span className="text-gray-300">+91 8788971006</span>
              </li>
              <li className="flex items-center gap-2 sm:gap-3">
                <div className="social-icon w-6 h-6 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FaEnvelope className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
                </div>
                <span className="text-gray-300 break-all">suresh@impacttogether.in</span>
              </li>
            </ul>
          </motion.div>

          {/* Socials */}
          <motion.div
            className="footer-card p-4 sm:p-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <h4 className="text-base sm:text-lg font-semibold text-white mb-3 sm:mb-4 flex items-center gap-2">
              <div className="w-1 h-4 sm:h-6 bg-gradient-to-b from-primary to-secondary rounded-full"></div>
              Connect With Us
            </h4>
            <div className="flex gap-2 sm:gap-3">
              <motion.a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaFacebook className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
              </motion.a>
              <motion.a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaXTwitter className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
              </motion.a>
              <motion.a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaLinkedin className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 py-4 sm:py-6 relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-0">
          <motion.p 
            className="text-gray-400 text-xs sm:text-sm flex items-center gap-2 text-center sm:text-left"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            © {new Date().getFullYear()} Impact Together. All rights reserved.
            <span className="text-primary hidden sm:inline">Made with <FaHeart className="inline w-3 h-3" /> for impact</span>
          </motion.p>
          <motion.div 
            className="flex flex-col sm:flex-row gap-3 sm:gap-6 text-center sm:text-left"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <Link to="/privacy" className="footer-link text-gray-400 hover:text-white text-xs sm:text-sm">Privacy Policy</Link>
            <Link to="/terms" className="footer-link text-gray-400 hover:text-white text-xs sm:text-sm">Terms of Service</Link>
            <a
    href="/sitemap.xml"
    target="_blank"
    rel="noopener noreferrer"
    className="footer-link text-gray-400 hover:text-white text-xs sm:text-sm"
  >
    Sitemap
  </a>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
